/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from "@iconify/react";
import {
    Box,
    ClickAwayListener,
    Grow,
    IconButton,
    Paper,
    Popper,
    Tooltip,
    useTheme,
    Stack,
    TextField,
    Button,
    Typography,
    Divider,
    Menu,
    MenuItem,
} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { ArchivedOrRestorePopup, AssignTaskPopup } from "src/components/dialogPopUp";
import { OpenDialogPopup } from "src/components/fullScreenPopUps";
import { useAddTreatment, useArchivedToggle, useAssignTaskToggle, useLeadTableHelper, useToggle } from "src/hooks";
import { clearLead, createNewLead, leadPage, saveNewLeadDetail, selectLeads, tableLead, updateSteps } from "src/redux/slices/lead";
import { setCurrentTreatmentDataGlobal } from "src/redux/slices/multiTreatment";
import { updateError } from "src/redux/slices/user";
import { addWhatsappTag, markAsUnRead, refreshThreadAndMessageInfo } from "src/redux/slices/whatsappV2";
import { PersonalDetails, TreatmentAndAppointment } from "src/sections/@dashboard/general/app";
import { handleLatestData } from "src/utils/getLeadLatestData";
import { updateLeadDataCount } from "src/redux/slices/whatsapp";
import { clearPracticeUserData } from "src/redux/slices/practiceUser";
import { borderRadiosStyle, zIndexStyle } from "src/styles/NewLead";
import TreatmentEditPopover from "../dashboard/tables/AllLeadTable/TreatmentEditPopover";
import { getStyles, ICON_COLORS } from "./styles";

const TAG_COLORS = ["#00A76F", "#2065D1", "#B76E00", "#D14343", "#6B778C", "#FF5630", "#22C55E", "#8B5CF6"];

const QuickActions = ({ onToggleDetails, detailsOpen, embedded, whatsppSendLoading, isSendAllowed, actionsRef, isMobile }) => {
    const theme = useTheme();
    const styles = getStyles(theme);
    const [leadState, setLeadState] = React.useState({});
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const inputRef = React.useRef();
    const [validStep, setValidStep] = React.useState(false);
    const [active, setActive] = React.useState(0);
    const [anchorEditTreatment, setAnchorEditTreatment] = React.useState(null);
    const [anchorElAssign, setAnchorElAssign] = React.useState(null);
    const [anchorElAddTags, setAnchorElAddTags] = React.useState(null);
    const [overflowAnchor, setOverflowAnchor] = React.useState(null);
    // Helper to create virtual anchor from click event for Popper positioning
    const getAnchorFromEvent = (event) => {
        const button = event?.currentTarget || event?.target?.closest('button');
        if (!button) return null;
        const rect = button.getBoundingClientRect();
        return {
            getBoundingClientRect: () => rect,
            nodeType: 1,
        };
    };
    const { toggle: openAddTags, onOpen: onOpenAddTags, onClose: onCloseAddTags } = useToggle();
    const [tagName, setTagName] = React.useState("");
    const [tagColor, setTagColor] = React.useState("#00A76F");
    const { handleTableData } = useLeadTableHelper('Dashboard');
    const onSubmit = (data) => {
        setValidStep(!!data);
    };

    const STEPS = [
        {
            label: 'Personal details',
            component: <PersonalDetails ref={inputRef} handleNext={onSubmit} active={active} />,
        },
        {
            label: 'Treatment & Appointment',
            component: <TreatmentAndAppointment type={'CreatLead'} ref={inputRef} handleNext={onSubmit} active={active} />,
        },
    ];
    // eslint-disable-next-line no-unused-vars
    const [leadStep, setLeadStep] = React.useState(STEPS);
    // Quick Action Chip dropdown state and handler
    // eslint-disable-next-line no-unused-vars
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { toggle: openArchiveLead, onOpen: onOpenArchiveLead, onClose: onCloseArchiveLead } = useArchivedToggle();
    const { toggle: openContacts, onOpen: onOpenContacts, onClose: onCloseContacts } = useToggle();
    const { toggle: openAddTreatment, onOpen: onOpenAddTreatment, onClose: onCloseAddTreatment } = useAddTreatment();
    const {
        toggle: openTreatmentEditPopup,
        onOpen: onopenTreatmentEditPopup,
        onClose: onCloseTreatmentEditPopup,
    } = useToggle();

    const { toggle: openAssignTask, onOpen: onOpenAssignTask, onClose: onCloseAssignTask } = useAssignTaskToggle();


    const {
        isLoading,
        whatsAppChatMetaData,
        practiceId,
        whatsappChatScreenLoading,
        markAsComplete,
        followUpLead,
        consentLink,
    } =
        useSelector(
            (state) => ({
                isLoading: state?.whatsappV2?.isLoading,
                whatsAppChatMetaData: state?.whatsappV2?.whatsAppChatMetaData,
                practiceId: state?.practiceTreatmentList?.practiceId,
                whatsappChatScreenLoading: state?.whatsappV2?.whatsappChatScreenLoading,
                activityList: state.activity?.activityList,
                lead: state.lead,
                markAsComplete: state?.lead?.markAsComplete,
                followUpLead: state?.lead?.followUpLead,
                consentLink: state?.lead?.consentLink,
            }),
            shallowEqual
        );

    React.useEffect(() => {
        const isLeadArchived = whatsAppChatMetaData?.leadDetails?.archived_at ?? false;
        const isNewLead = !whatsAppChatMetaData?.leadDetails?.id;
        const leadId = whatsAppChatMetaData?.leadDetails?.id;
        const threadId = whatsAppChatMetaData?.thread?.id;
        const firstName = whatsAppChatMetaData?.name?.split(" ")?.[0] ?? "";
        const phoneNumber = whatsAppChatMetaData?.phoneNumber ?? "";
        const lead = whatsAppChatMetaData?.leadDetails;
        setLeadState({
            isLeadArchived,
            isNewLead,
            leadId,
            threadId,
            firstName,
            phoneNumber,
            lead
        });
    }, [whatsAppChatMetaData]);

    const handleAction = (label, event) => {
        setAnchorEl(null);
        if (label === "Open Details") {
            // Toggle details sidebar instead of navigating
            if (onToggleDetails) {
                onToggleDetails();
            } else {
                // Fallback to navigation if callback not provided
                dispatch(leadPage({ name: 'All Leads', path: location.pathname }));
                if (leadState?.isLeadArchived)
                    navigate(`/dashboard/practice/${practiceId}/archived/${leadState?.leadId}`);
                else navigate(`/dashboard/practice/${practiceId}/lead-detail/${leadState?.leadId}`);
            }
        } else if (label === "Restore Lead") {
            const row = { leadId: [leadState?.leadId], type: "Restore" }
            dispatch(selectLeads(row));
            onOpenArchiveLead(row);
        }
        else if (label === "Mark as Unread") {
            dispatch(markAsUnRead(leadState?.threadId));
        }
        else if (label === "Book Appointment") {
            // x
        }
        else if (label === "Change Assignee") {
            if (openAssignTask) {
                onCloseAssignTask();
                setAnchorElAssign(null);
            } else {
                setAnchorElAssign(getAnchorFromEvent(event));
                onOpenAssignTask();
            }
            onCloseTreatmentEditPopup();
        }
        else if (label === "Change Treatment") {
            if (openTreatmentEditPopup) {
                onCloseTreatmentEditPopup();
                setAnchorEditTreatment(null);
            } else {
                setAnchorEditTreatment(getAnchorFromEvent(event));
                onopenTreatmentEditPopup();
                dispatch(tableLead(leadState?.lead));
            }
        } else if (label === "Add Treatment") {
            if (openAddTreatment) {
                onCloseAddTreatment();
                setAnchorEditTreatment(null);
            } else {
                setAnchorEditTreatment(getAnchorFromEvent(event));
                onOpenAddTreatment('openAddTreatment');
                dispatch(tableLead(leadState?.lead));
            }
        } else if (label === "Create Lead") {
            dispatch(saveNewLeadDetail({
                personalDetail: {
                    first_name: leadState?.firstName,
                    lead_contact: {
                        phone: leadState?.phoneNumber
                    }
                }
            }));
            onOpenContacts();
            dispatch(setCurrentTreatmentDataGlobal(null));
        } else if (label === "Add Tags") {
            if (openAddTags) {
                onCloseAddTags();
                setAnchorElAddTags(null);
            } else {
                setAnchorElAddTags(getAnchorFromEvent(event));
                onOpenAddTags();
            }
        }
    };

    const handleCloseAddTags = () => {
        onCloseAddTags();
        setAnchorElAddTags(null);
        setTagName("");
        setTagColor("#00A76F");
    };

    const handleSaveTag = () => {
        dispatch(addWhatsappTag(leadState?.threadId, tagName, tagColor));
        onCloseAddTags();
        setAnchorElAddTags(null);
        setTagName("");
        setTagColor("#00A76F");
    };

    const handleArchiveClose = () => {
        dispatch(refreshThreadAndMessageInfo(leadState?.threadId, leadState?.leadId));
        dispatch(tableLead(null));
        dispatch(selectLeads(null));
        onCloseArchiveLead();
    }

    const handleCloseLead = React.useCallback((status, id) => {
        if (status?.toLowerCase?.() === 'finish') {
            setTimeout(() => {
                dispatch(
                    updateError({
                        success: true,
                        message: 'Lead successfully created! Refresh the page or click \'Show Lead\' to view and manage it.',
                        lead: id,
                        timeout: 10000,
                    })
                );
            }, 4000);
        }
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        onCloseContacts();
        if (id)
            dispatch(refreshThreadAndMessageInfo(leadState?.threadId, id, true, true));
    }, [dispatch, leadState?.threadId]);

    const handleCloseAddTreatment = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onCloseAddTreatment();
                setAnchorEditTreatment(null);
                return;
            }
            return;
        }
        onCloseAddTreatment();
        dispatch(refreshThreadAndMessageInfo(leadState?.threadId, leadState?.leadId));
        setAnchorEditTreatment(null);
    };

    const handleCloseEditTreatment = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onCloseTreatmentEditPopup();
                setAnchorEditTreatment(null);
                return;
            }
            return;
        }
        onCloseTreatmentEditPopup();
        setAnchorEditTreatment(null);
        dispatch(refreshThreadAndMessageInfo(leadState?.threadId, leadState?.leadId));
    };

    const onClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAssignTask();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const handleCloseAssignPopup = (isReload) => {
        if (isReload) {
            dispatch(refreshThreadAndMessageInfo(leadState?.threadId, leadState?.leadId));
        }
        onCloseAssignTask();
        setAnchorElAssign(null);
    };

    // Expose handlers to parent via ref (imperative handle pattern)
    if (actionsRef) {
        actionsRef.current = {
            createLead: () => handleAction('Create Lead'),
            openMenu: (e) => handleOverflowOpen(e),
        };
    }

    const handleOverflowOpen = (e) => setOverflowAnchor(e.currentTarget);
    const handleOverflowClose = () => setOverflowAnchor(null);

    React.useEffect(() => {
        if (markAsComplete && !followUpLead && !consentLink && openContacts) {
            dispatch(createNewLead(handleCloseLead));
        }
    }, [markAsComplete, followUpLead, consentLink, openContacts, dispatch]);

    // Loading state
    if (isLoading || whatsappChatScreenLoading) return <Box sx={{
        ...styles.actionBar,
        ...(isMobile && {
            position: 'relative',
            '&::after': {
                content: '""',
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
                width: '24px',
                background: 'linear-gradient(to right, transparent, #F4F6F8)',
                pointerEvents: 'none',
                zIndex: 1,
            },
        }),
    }} />

    // Action Button Component — icon-only with Tooltip
    const ActionButton = ({ icon, label, onClick, isActive = false, iconColor = null }) => {
        const isDisabled = whatsppSendLoading || !isSendAllowed;
        let tooltipTitle = label;
        if (whatsppSendLoading) tooltipTitle = "Sending message...";
        else if (!isSendAllowed) tooltipTitle = "Loading lead details...";

        return (
            <Tooltip title={tooltipTitle} arrow>
                <span>
                    <IconButton
                        onClick={onClick}
                        size="small"
                        disabled={isDisabled}
                        sx={{
                            ...styles.actionIconBtn,
                            ...(isActive ? styles.actionIconBtnActive : {}),
                        }}
                    >
                        <Icon icon={icon} width={18} height={18} style={iconColor ? { color: iconColor } : {}} />
                    </IconButton>
                </span>
            </Tooltip>
        );
    };

    const OverflowMenu = () => (
        <Menu
            anchorEl={overflowAnchor}
            open={Boolean(overflowAnchor)}
            onClose={handleOverflowClose}
            slotProps={{ paper: { sx: { borderRadius: '10px', minWidth: 180, mt: 0.5 } } }}
        >
            <MenuItem onClick={() => { handleAction('Mark as Unread'); handleOverflowClose(); }} sx={{ gap: 1, fontSize: '13px' }}>
                <Icon icon="solar:chat-unread-outline" width={16} height={16} style={{ color: ICON_COLORS.unread }} />
                Mark Unread
            </MenuItem>
        </Menu>
    );

    // New Lead Actions — no visible action bar, only the create lead dialog
    if (leadState?.isNewLead)
        return (
            <>
                {openContacts && (
                    <OpenDialogPopup
                        key={`createLead-${leadState?.threadId}`}
                        open={openContacts}
                        onClose={handleCloseLead}
                        steps={leadStep}
                        type={'createLead'}
                        validStep={validStep}
                        updateStep={(type) => setValidStep(type)}
                        inputRef={inputRef}
                        title="Create Lead"
                        headerButtons
                        setActive={setActive}
                    />
                )}
            </>
        );

    // Archived Lead Actions
    if (leadState?.isLeadArchived)
        return (
            <Box sx={{
                ...styles.actionBar,
                ...(isMobile && {
                    position: 'relative',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        bottom: 0,
                        width: '24px',
                        background: 'linear-gradient(to right, transparent, #F4F6F8)',
                        pointerEvents: 'none',
                        zIndex: 1,
                    },
                }),
            }}>
                {!embedded && (
                    <ActionButton
                        icon="mdi:card-account-details-outline"
                        label="Details"
                        onClick={(e) => handleAction('Open Details', e)}
                        iconColor={ICON_COLORS.details}
                        isActive={detailsOpen}
                    />
                )}
                <ActionButton
                    icon="ic:twotone-restore"
                    label="Restore Lead"
                    onClick={(e) => handleAction('Restore Lead', e)}
                    iconColor={ICON_COLORS.treatment}
                />
                <Tooltip title={(() => { if (whatsppSendLoading) return "Sending message..."; if (!isSendAllowed) return "Loading lead details..."; return "More actions"; })()} arrow>
                    <span>
                        <IconButton onClick={handleOverflowOpen} size="small" disabled={whatsppSendLoading || !isSendAllowed} sx={styles.overflowBtn}>
                            <Icon icon="mdi:dots-horizontal" width={18} height={18} />
                        </IconButton>
                    </span>
                </Tooltip>
                <OverflowMenu />
                {openArchiveLead &&
                    <ArchivedOrRestorePopup open={openArchiveLead} onClose={handleArchiveClose} handleClose={handleArchiveClose} />}
            </Box>
        );

    // Regular Lead Actions
    const getMenuAnchor = () => ({
        getBoundingClientRect: () => overflowAnchor?.getBoundingClientRect() || new DOMRect(),
        nodeType: 1,
    });

    const hasTreatments = leadState?.lead?.lead_treatments?.length > 0;

    if (!leadState?.isLeadArchived && leadState?.leadId)
        return (
            <>
                {/* Combined Actions Menu — triggered from header via actionsRef.openMenu */}
                <Menu
                    anchorEl={overflowAnchor}
                    open={Boolean(overflowAnchor)}
                    onClose={handleOverflowClose}
                    slotProps={{ paper: { sx: { borderRadius: '10px', minWidth: 200, mt: 0.5, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' } } }}
                >
                    {!embedded && (
                        <MenuItem onClick={() => { handleAction('Open Details'); handleOverflowClose(); }} sx={{ gap: 1.5, fontSize: '13px', py: 1 }}>
                            <Icon icon="mdi:card-account-details-outline" width={18} height={18} style={{ color: ICON_COLORS.details }} />
                            Open Details
                        </MenuItem>
                    )}
                    <MenuItem onClick={() => {
                        handleOverflowClose();
                        setAnchorElAddTags(getMenuAnchor());
                        onOpenAddTags();
                    }} sx={{ gap: 1.5, fontSize: '13px', py: 1 }}>
                        <Icon icon="stash:save-ribbon-solid" width={18} height={18} style={{ color: ICON_COLORS.tag }} />
                        Add Tag
                    </MenuItem>
                    <MenuItem onClick={() => {
                        handleOverflowClose();
                        setAnchorElAssign(getMenuAnchor());
                        onOpenAssignTask();
                    }} sx={{ gap: 1.5, fontSize: '13px', py: 1 }}>
                        <Icon icon="mdi:account-switch-outline" width={18} height={18} style={{ color: ICON_COLORS.assign }} />
                        Change Assignee
                    </MenuItem>
                    <MenuItem onClick={() => {
                        handleOverflowClose();
                        const anchor = getMenuAnchor();
                        setAnchorEditTreatment(anchor);
                        if (hasTreatments) {
                            onopenTreatmentEditPopup();
                        } else {
                            onOpenAddTreatment('openAddTreatment');
                        }
                        dispatch(tableLead(leadState?.lead));
                    }} sx={{ gap: 1.5, fontSize: '13px', py: 1 }}>
                        <Icon icon="tabler:dental" width={18} height={18} style={{ color: ICON_COLORS.treatment }} />
                        {hasTreatments ? 'Change Treatment' : 'Add Treatment'}
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => { handleAction('Mark as Unread'); handleOverflowClose(); }} sx={{ gap: 1.5, fontSize: '13px', py: 1 }}>
                        <Icon icon="solar:chat-unread-outline" width={18} height={18} style={{ color: ICON_COLORS.unread }} />
                        Mark Unread
                    </MenuItem>
                </Menu>

                {/* Add Tags Popper */}
                {openAddTags && anchorElAddTags && (
                    <ClickAwayListener onClickAway={handleCloseAddTags}>
                        <Popper
                            open={openAddTags}
                            anchorEl={anchorElAddTags}
                            transition
                            placement='bottom-start'
                            sx={zIndexStyle}
                            modifiers={[
                                { name: 'offset', options: { offset: [0, 8] } },
                                { name: 'preventOverflow', options: { boundary: 'viewport', padding: 8 } },
                            ]}
                        >
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={{ p: 2, minWidth: 300, ...borderRadiosStyle, border: '1px solid', borderColor: 'divider', borderRadius: '0.75rem' }}>
                                        <Stack spacing={1.5}>
                                            <Typography variant="subtitle2" fontWeight={600}>Add a tag</Typography>
                                            <TextField
                                                size="small"
                                                value={tagName}
                                                onChange={(e) => setTagName(e.target.value)}
                                                placeholder="Enter tag name (e.g, New Lead, Critical)"
                                                inputProps={{ maxLength: 50 }}
                                                fullWidth
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '0.5rem',
                                                    }
                                                }}
                                            />
                                            <Stack spacing={0.75}>
                                                <Typography variant="caption" color="text.secondary">Color</Typography>
                                                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', rowGap: 1 }}>
                                                    {TAG_COLORS.map((c) => (
                                                        <IconButton
                                                            key={c}
                                                            size="small"
                                                            onClick={() => setTagColor(c)}
                                                            sx={{
                                                                width: 28,
                                                                height: 28,
                                                                borderRadius: '50%',
                                                                bgcolor: c,
                                                                position: 'relative',
                                                                border: (theme) => `2px solid ${tagColor === c ? theme.palette.common.black : theme.palette.common.white}`,
                                                                boxShadow: tagColor === c ? 2 : 0,
                                                                '&:hover': {
                                                                    bgcolor: c,
                                                                },
                                                            }}
                                                        >
                                                            {tagColor === c && (
                                                                <Icon icon="mdi:check-bold" style={{ fontSize: 16, color: '#fff' }} />
                                                            )}
                                                        </IconButton>
                                                    ))}
                                                </Stack>
                                            </Stack>
                                            <Divider />
                                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                <Button onClick={handleCloseAddTags} size="small" sx={{ borderRadius: '0.5rem' }}>Cancel</Button>
                                                <Button variant="contained" onClick={handleSaveTag} size="small" disabled={!tagName?.trim()} sx={{ borderRadius: '0.5rem', bgcolor: '#00A76F', '&:hover': { bgcolor: '#007B55' } }}>Save</Button>
                                            </Stack>
                                        </Stack>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}

                {/* Add Treatment Popover */}
                {openAddTreatment && (
                    <TreatmentEditPopover
                        handleReloadAPI={() => {
                            const latestData = handleLatestData(leadState?.lead, 'Whatsapp', 'All');
                            const row = handleTableData(leadState?.lead, latestData);
                            const payload = {
                                lead_id: Number(row?.id?.toString()?.split("-")?.[0] || '0'),
                                first_name: row.first_name || '',
                                last_name: row.last_name || '',
                                treatmentData: latestData?.[0]
                            };
                            dispatch(setCurrentTreatmentDataGlobal(payload));
                            dispatch(updateLeadDataCount({ hasUpdated: true, data: leadState?.lead }));
                        }}
                        open={openAddTreatment}
                        anchorEl={anchorEditTreatment}
                        handleClickAwayLister={handleCloseAddTreatment}
                        leadId={leadState?.lead?.id}
                        isAddTreatment
                        placement="bottom"
                    />
                )}

                {/* Edit Treatment Popover */}
                {openTreatmentEditPopup && (
                    <TreatmentEditPopover
                        handleReloadAPI={() => {
                            const latestData = handleLatestData(leadState?.lead, 'Whatsapp', 'All');
                            const row = handleTableData(leadState?.lead, latestData);
                            const payload = {
                                lead_id: Number(row?.id?.toString()?.split("-")?.[0] || '0'),
                                first_name: row.first_name || '',
                                last_name: row.last_name || '',
                                treatmentData: row?.treatmentData?.find((ele) => ele.id === row?.treatment_id)
                            };
                            dispatch(setCurrentTreatmentDataGlobal(payload));
                            dispatch(updateLeadDataCount({ hasUpdated: true, data: leadState?.lead }));
                        }}
                        treatmentData={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.treatmentData}
                        treatment={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.treatment_name || ''}
                        leadTreatmentSpecification={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.leadTreatmentSpecification || null}
                        open={openTreatmentEditPopup}
                        anchorEl={anchorEditTreatment}
                        handleClickAwayLister={handleCloseEditTreatment}
                        treatmentId={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.treatment_id}
                        treatmentPrice={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.price}
                        treatmentCategory={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.treatmentCategory}
                        leadId={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.lead_id}
                        placement="bottom"
                    />
                )}

                {/* Assign Task Popup */}
                {openAssignTask && anchorElAssign && (
                    <ClickAwayListener onClickAway={onClickAwayEvent}>
                        <Popper
                            open={openAssignTask}
                            anchorEl={anchorElAssign}
                            transition
                            placement='bottom-start'
                            sx={zIndexStyle}
                            modifiers={[
                                { name: 'offset', options: { offset: [0, 8] } },
                                { name: 'preventOverflow', options: { boundary: 'viewport', padding: 8 } },
                            ]}
                        >
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper sx={{ ...borderRadiosStyle, borderRadius: '0.75rem' }}>
                                        <AssignTaskPopup
                                            open={openAssignTask}
                                            onClose={handleCloseAssignPopup}
                                            user={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))}
                                            leadId={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.lead_id}
                                            type={'leadAssign'}
                                            assignees={handleTableData(leadState?.lead, handleLatestData(leadState?.lead, 'Whatsapp', 'All'))?.assignees?.filter(
                                                (el) => el?.user?.first_name && !el?.user?.is_superuser)?.map((ele) => ele.id)}
                                        />
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ClickAwayListener>
                )}
            </>
        );

    return null;
}

QuickActions.propTypes = {
    onToggleDetails: PropTypes.func,
    detailsOpen: PropTypes.bool,
    embedded: PropTypes.bool,
    whatsppSendLoading: PropTypes.bool,
    isSendAllowed: PropTypes.bool,
    isMobile: PropTypes.bool,
};

QuickActions.defaultProps = {
    onToggleDetails: null,
    detailsOpen: false,
    embedded: false,
    whatsppSendLoading: false,
    isSendAllowed: true,
    isMobile: false,
};

export default QuickActions;
